export const zhCnLocale = {
  model: {
    adminUsersRole: '管理员'
  },
  adminUsersRole: {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    roleId: '角色',
    adminUserId: 'Admin user',
    applicationId: '应用ID',
    role: '角色',
    application: '应用管理',
    adminUser: '管理员',
  }
}

export const enLocale = {
  model: {
    adminUsersRole: 'Admin user'
  },
  adminUsersRole: {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    roleId: 'Role',
    adminUserId: 'Admin user',
    applicationId: 'Application',
    role: 'Role',
    application: 'Application',
    adminUser: 'Admin user',
  }
}

